(function () {
  const SELECTOR_BUTTON = '[data-compare-buy-add]';
  const SELECTOR_ERROR = '[data-compare-buy-error]';
  const SELECTOR_SECTION = '[data-compare-buy-section]';

  function getErrorMessage(button) {
    const section = button.closest(SELECTOR_SECTION);
    return section?.dataset.errorMessage
      || 'カートに追加できませんでした。';
  }

  function showError(button, message) {
    const set = button.closest('.senchado-compare-buy__set');
    const errorEl = set?.querySelector(SELECTOR_ERROR);
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    }
  }

  function clearError(button) {
    const set = button.closest('.senchado-compare-buy__set');
    const errorEl = set?.querySelector(SELECTOR_ERROR);
    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }
  }

  async function addToCart(variantIds, button) {
    const items = variantIds.map((id) => ({ id: Number(id), quantity: 1 }));
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    });

    if (!response.ok) {
      let message = getErrorMessage(button);
      try {
        const data = await response.json();
        if (data?.description) message = data.description;
        else if (data?.message) message = data.message;
      } catch (_) {}
      throw new Error(message);
    }

    return response.json();
  }

  function notifyCartUpdate() {
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest(SELECTOR_BUTTON);
    if (!button) return;
    event.preventDefault();

    // 先行発売ロック（監査 H9）: Cart Function無効（Plus必須）でサーバーガードが無いため、
    // disabled が外されてもここで必ず /cart/add.js を止める。
    if (button.dataset.earlyLocked === 'true') return;

    const raw = button.dataset.variantIds || '';
    const variantIds = raw.split(',').map((s) => s.trim()).filter(Boolean);
    if (variantIds.length === 0) return;

    clearError(button);
    button.disabled = true;
    button.dataset.state = 'loading';
    const originalText = button.textContent;
    button.textContent = '追加中...';

    try {
      await addToCart(variantIds, button);
      button.dataset.state = 'success';
      button.textContent = 'カートに追加しました';
      notifyCartUpdate();
      setTimeout(() => {
        button.disabled = false;
        delete button.dataset.state;
        button.textContent = originalText;
      }, 2000);
    } catch (err) {
      showError(button, err.message);
      button.disabled = false;
      delete button.dataset.state;
      button.textContent = originalText;
    }
  });
})();
